import React from "react";
import AddCommonPlaceholder from "./AddCommonPlaceholder";

// Estilos CSS
const styles = {
  container: {
    display: "flex",
    gap: "8px",
    alignItems: "flex-start",
    position: "relative",
  },
  textArea: {
    flex: 1,
    padding: "12px",
    fontSize: "14px",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    border: "1px solid #ddd",
    borderRadius: "4px",
    resize: "vertical",
    minHeight: "100px",
    outline: "none",
    transition: "border-color 0.2s",
  },
  textAreaFocused: {
    borderColor: "#1976d2",
  },
  label: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "8px",
    display: "block",
  },
  wrapper: {
    width: "100%",
  },
};

export default function PlaceholderSelector({
  value = "",
  onChange,
  label = "Conteúdo",
  placeholder = "Digite aqui...",
}) {
  const [isTextAreaFocused, setIsTextAreaFocused] = React.useState(false);

  const textAreaRef = React.useRef(null);

  const handleTextChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div style={styles.wrapper}>
      {label && <label style={styles.label}>{label}</label>}
      <div style={styles.container}>
        <textarea
          ref={textAreaRef}
          value={value}
          onChange={handleTextChange}
          placeholder={placeholder}
          style={{
            ...styles.textArea,
            ...(isTextAreaFocused ? styles.textAreaFocused : {}),
          }}
          onFocus={() => setIsTextAreaFocused(true)}
          onBlur={() => setIsTextAreaFocused(false)}
        />

        <AddCommonPlaceholder
          onChange={onChange}
          value={value}
          textAreaRef={textAreaRef}
        />
      </div>
    </div>
  );
}
